import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { findBusiness, getBusiness } from "../../../api/business";

export const fetchBusinessTypes = createAsyncThunk(
  "/business-type",
  async () => {
    const res = await findBusiness();
    return res;
  }
);
export const fetchBusiness = createAsyncThunk("/business", async () => {
  const res = await getBusiness();
  return res;
});

const businessSlice = createSlice({
  name: "business",
  initialState: {
    isLoading: false,
    value: [],
    business: [],
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBusinessTypes.fulfilled, (state, action) => {
        state.value = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBusinessTypes.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(fetchBusiness.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBusiness.fulfilled, (state, action) => {
        state.business = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBusiness.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      });
  },
});

export { businessSlice };
